import { Flex } from "@aircall/tractor";
import { Trans, useTranslation } from "react-i18next";
import TranscriptionOff from "@/assets/transcription_off.svg?react";
import { TranscriptionIllustrationLayout } from "../TranscriptionIllustrationLayout/TranscriptionIllustrationLayout";
import { TranscriptionMessageTitle } from "../TranscriptionMessageTitle/TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../TranscriptionSubTitle/TranscriptionSubTitle";

/**
 * Shown when a call has no usable transcription and no more specific reason applies
 * (i.e. `transcriptStatus` is undefined). This covers a transcription that failed to
 * load or was never generated, so the panel shows an empty state instead of rendering
 * blank. [CI-6183]
 */
export function TranscriptionNotFound() {
  const { t } = useTranslation();

  return (
    <TranscriptionIllustrationLayout data-test="transcription-not-found">
      <TranscriptionOff />
      <Flex flexDirection="column" alignItems="center" gap="s" maxW="560px">
        <TranscriptionMessageTitle data-test="transcription-not-found-title">
          <Trans
            i18nKey="no_transcript.not_found"
            components={{ bold: <b /> }}
          />
        </TranscriptionMessageTitle>
        <TranscriptionSubTitle data-test="transcription-not-found-description">
          {t("no_transcript.not_found_description")}
        </TranscriptionSubTitle>
      </Flex>
    </TranscriptionIllustrationLayout>
  );
}
